import React from "react";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  toolbarContent: {
    flexGrow: 1,
    flexShrink: 0,
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
  },
}));

export default ({ children }) => {
  const classes = useStyles();
  return <div className={classes.toolbarContent}>{children}</div>;
};
